/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./max')} */
module.exports = Math.max;

